import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import 'styles/main.scss'
import { router } from '@/router'
import { LoadingProvider } from '@context/LoadingContext'
import { ErrorBoundary } from '@components/error/ErrorBoundary'
import { themeTokens, applyThemeToRoot, layoutDimensions } from '@theme/tokens';

// Create source of truth for color palette
applyThemeToRoot(themeTokens, undefined, layoutDimensions);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ConfigProvider
      theme={{token: themeTokens}}
      >
    <ErrorBoundary>
      <LoadingProvider>
        <RouterProvider router={router} />
      </LoadingProvider>
    </ErrorBoundary>
    </ConfigProvider>
  </StrictMode>,
)
